import React, { useMemo } from 'react';

import { InquireType, MasterInquireApiResponse } from '../../types/api/MasterInquireApiType';
import { ContactInputType, CONTACT_TYPE_REMOVAL_SERVICE } from '../../types/common/ContactType';

import { ErrorMessage } from '../../components/ErrorMessage';

type ContactInputProps = {
    dataInput: boolean; // 入力モード true:入力/false：参照
    contactInput: ContactInputType; // 入力内容
    setContactInput: (value: ContactInputType) => void; // 入力内容setState
    inquireErrorMessage: string;
    textErrorMessage: string;
    masterInquireData: MasterInquireApiResponse;
};

// 問い合わせ入力
export const ContactInput: React.FC<ContactInputProps> = ({
    dataInput,
    contactInput,
    setContactInput,
    inquireErrorMessage,
    textErrorMessage,
    masterInquireData,
}) => {
    // お問い合わせ種別
    const inquireType = useMemo<Array<InquireType>>(() => masterInquireData.inquire_type, [masterInquireData]);

    // お問い合わせの種別 チェックボックス更新
    const checkInquireType = (value: string) => {
        if (contactInput.checkedInquire.includes(value)) {
            const filter = contactInput.checkedInquire.filter((checkout) => checkout != value);
            setContactInput({ ...contactInput, checkedInquire: [...filter] });
        } else {
            setContactInput({ ...contactInput, checkedInquire: [...contactInput.checkedInquire, value] });
        }
    };

    return (
        <>
            <div className='columns form-item_area is-multiline is-variable is-1-mobile is-1-tablet is-4-desktop is-6-widescreen is-6-fullhd'>
                <div className='column '>
                    <div className='field'>
                        <div className='label is-normal'>
                            <label className='label required'>お問い合わせ種別</label>
                        </div>
                        <p className='help contact'>
                            お問い合わせの種別を選択してください。（複数可）
                            <br />
                            ストレージ、ネットワーク、サーバーの各機器のEOL/EOSL延長保守に関するお問い合わせ、お手元の機器リストによる概算見積依頼、将来のEOLに備える対策・基盤更改サイクルのご計画等のご相談にもご対応いたします。
                        </p>
                        <div className='field-body'>
                            <div className='field contact'>
                                <div className='control'>
                                    {inquireType &&
                                        inquireType.map((inquire, index) => (
                                            <label className='checkbox' key={`connect-Inquire-type-${index}`}>
                                                <input
                                                    type='checkbox'
                                                    name='answer'
                                                    value={inquire.inquire_type_id}
                                                    checked={contactInput?.checkedInquire.includes(
                                                        inquire.inquire_type_id.toString()
                                                    )}
                                                    onChange={(e) => checkInquireType(e.target.value)}
                                                    disabled={!dataInput}
                                                />
                                                {inquire.inquire_type_name}
                                            </label>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    {inquireErrorMessage && <ErrorMessage errorMessage={inquireErrorMessage} />}
                </div>
            </div>
            <hr />
            <div className='columns form-item_area is-multiline is-variable is-1-mobile is-1-tablet is-4-desktop is-6-widescreen is-6-fullhd'>
                <div className='column '>
                    <div className='field'>
                        <div className='label is-normal'>
                            <label className='label required'>お問い合わせ詳細・備考</label>
                        </div>
                        <p className='help contact'>
                            各種お問い合わせ詳細内容、及び補足事項などがありましたらご入力ください。
                        </p>
                        <div className='field-body'>
                            <div className='field contact'>
                                <div className='control contact--textarea'>
                                    <textarea
                                        className='textarea'
                                        rows={4}
                                        placeholder='お問い合わせ内容を入力してください。'
                                        onChange={(e) =>
                                            setContactInput({ ...contactInput, contactText: e.target.value })
                                        }
                                        value={contactInput.contactText}
                                        disabled={!dataInput}
                                    />
                                    {!contactInput.checkedInquire.includes(CONTACT_TYPE_REMOVAL_SERVICE) ? (
                                        <div className='textarea_message'>
                                            <p>
                                                保守対応可否やお見積をお急ぎの場合は、
                                                <br />
                                                1. メーカー名
                                                <br />
                                                2. 機種
                                                <br />
                                                3. 台数
                                                <br />
                                                4. 設置場所（都道府県・市区郡）
                                                <br />
                                                5. ご希望の保守レベル
                                                <br />
                                                （平日9-17時、平日9-17時（翌営業日）、
                                                <br />
                                                　24×365、またはパーツ保守）
                                                <br />
                                                6. ご希望の保守期間・開始予定年月
                                                <br />
                                                を記載してください。
                                            </p>
                                        </div>
                                    ) : (
                                        <div className='textarea_message'>
                                            <p>
                                                買取対応可否や買取お見積をお急ぎの場合は、
                                                <br />
                                                1. メーカー名
                                                <br />
                                                2. 機種
                                                <br />
                                                3. 台数（内蔵HDD/SSD本数）
                                                <br />
                                                4. 設置場所（都道府県・市区郡）
                                                <br />
                                                5. 必要な引き取り作業（アンラック等）
                                                <br />
                                                6. 消去作業の有無（実施時には消去証明書を発行）
                                                <br />
                                                7. ご希望の作業時期
                                                <br />
                                                を記載してください。
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    {textErrorMessage && <ErrorMessage errorMessage={textErrorMessage} />}
                </div>
            </div>

            <div className='columns form-item_area is-multiline is-variable is-1-mobile is-1-tablet is-4-desktop is-6-widescreen is-6-fullhd'>
                <div className='column '>
                    <div className='field'>
                        <p className='help questionnaire'>
                            対象機器リストをファイルで送付希望の方はこちらを選択してください。後日、弊社担当者よりご連絡させていただきます。
                        </p>
                        <div className='field-body'>
                            <div className='field questionnaire'>
                                <div className='control'>
                                    <label className='checkbox'>
                                        <input
                                            type='checkbox'
                                            name='answer'
                                            checked={contactInput.equipmentListRequest}
                                            onChange={(e) =>
                                                setContactInput({
                                                    ...contactInput,
                                                    equipmentListRequest: e.target.checked,
                                                })
                                            }
                                            disabled={!dataInput}
                                        />
                                        機種リスト送付希望
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='call-text'>お急ぎの場合は、03-5684-5413（営業窓口）までお電話ください。</div>
        </>
    );
};
